import React from 'react'
import { ToastContainer, Slide, Icons } from 'react-toastify'
import styles from './styles/alerts.module.scss'
import { withModals } from 'hooks/use-modal'
import { watchlistsModalsState } from 'constants/modals'
import useInteractiveNotitfications from 'hooks/use-interactive-notifications'
import {
  withManagePlayer,
  Context as ManagePlayerInWatchlistCtx,
} from 'components/notifications/ManagePlayerInWatchlist'
import { ReactComponent as IconError } from 'images/icons/icn_danger.svg'

const AlertsContainer = () => {
  useInteractiveNotitfications<ManagePlayerInWatchlistCtx>('watchlists', withManagePlayer)
  return (
    <ToastContainer
      autoClose={2000}
      position='top-right'
      theme='light'
      className={styles.alert}
      toastClassName={styles.toast}
      hideProgressBar
      transition={Slide}
      newestOnTop
      icon={({ type, theme }) => {
        if (type === 'error') return <IconError aria-hidden />
        const Icon = Icons[type] ? Icons[type] : Icons['success']
        return <Icon aria-hidden />
      }}
    />
  )
}

export default withModals(AlertsContainer, watchlistsModalsState)
